import { dispatch, getState } from "@rematch/core";

//import { saveAs } from "file-saver/FileSaver";
// import { message } from "antd";

import fileDownload from "js-file-download";

//import axios from "axios";

import moment from "moment";

import { message } from "antd";

import initTmpNotice from "./tmpNotice";

// 消息通知增强组件
export default class noticeEnhance {
  static handleNotice(noticeInfo, addNotice, syncClose, callback) {
    const notice = noticeInfo;
    try {
      if (typeof notice.data === "string") {
        notice.data = JSON.parse(notice.data);
      }
    } catch (error) {
      console.warn(error);
      return;
    }

    console.log("notice", notice);
    // 消息分类
    switch (Number(notice.data.type)) {
      // 1 ~ 3 为模板消息
      case 1:
      case 2:
      case 3:
        // 更新消息列表
        // dispatch["globalStatus"].updateExportProcess({
        //   num: notice.data.loading,
        //   status: "active"
        // });
        // 收到消息后需要触发的事件 比如更新未读消息统计
        callback && callback();
        initTmpNotice(notice.data, notice.swId, syncClose);
        addNotice(notice.data);
        break;
      // 导出消息
      case 100:
        const store = getState();
        if (store.globalStatus.exportProcess.num >= 100) {
          dispatch["globalStatus"].updateExportProcess({
            num: 0,
            status: ""
          });
        } else if (
          Number(notice.data.loading) === 100 &&
          notice.msg === "complete" &&
          notice.data.file
        ) {
          //downloadFile(notice.data.file);
          // downloadFile(
          //   notice.data.file,
          //   "子订单导表_" + moment().format("YYYYMMDDHHmmss") + ".csv"
          // );

          // 更新导出进度 为已完成
          dispatch["globalStatus"].updateExportProcess({
            num: 100,
            status: "complete"
          });
        } else {
          // 更新导出进度
          dispatch["globalStatus"].updateExportProcess({
            num: notice.data.loading,
            status: "active"
          });
        }
        break;
      // 自定义消息类型
      case 9999:
        console.log("自定义消息", notice);
        if (notice.data.loading == 100) {
          dispatch["globalStatus"].updateDownloadProcess({
            num: 100,
            status: "end" // normal| null, start, end
          });

          message.success("导出成功");
          setTimeout(() => {
            // notification.close("ExportProcess");
            dispatch["globalStatus"].updateDownloadProcess({
              num: 0,
              status: "" // normal| null, start, end
            });
            // 更新导出进度 为已完成
            dispatch["globalStatus"].updateExportProcess({
              num: 0,
              status: ""
            });
          }, 500);

          if (notice.data.isDown === true) {
            fileDownload(
              notice.data.file,
              "子订单导表_" +
                moment().format("YYYYMMDDHHmmss") +
                "." +
                (notice.data.suffix || "csv")
            );
          }
        } else {
          dispatch["globalStatus"].updateExportProcess({
            num: 0,
            status: ""
          });
          dispatch["globalStatus"].updateDownloadProcess({
            num: parseInt(notice.data.loading),
            status: "start" // normal| null, start, end
          });
        }
        break;
      case 101:
        console.log(66666);
        break;
      default:
        break;
    }
  }
}
